'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEG = 3.6; // 360°
var RAD = 180; // 180°
var DIA = 24; // Diameter
var PI = 3.14; // ~π, because IE

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('PieChart', function () {
  return {
    svgIcon: {
      border: '0.075em solid currentColor',
      borderRadius: '50%',
      padding: '0.055em',
      transform: 'rotate(-90deg)'
    }
  };
});

var PieChart = (_temp = _class = function (_SvgIcon) {
  _inherits(PieChart, _SvgIcon);

  function PieChart() {
    _classCallCheck(this, PieChart);

    return _possibleConstructorReturn(this, (PieChart.__proto__ || Object.getPrototypeOf(PieChart)).apply(this, arguments));
  }

  _createClass(PieChart, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            className = _props.className,
            value = _props.value,
            other = _objectWithoutProperties(_props, ['className', 'value']);

        var deg = value * DEG;
        var rad = deg * PI / RAD;
        var cos = Math.cos(rad) * DIA;
        var sin = Math.sin(rad) * DIA;
        var classes = this.context.styleManager.render(styleSheet);

        return _react2['default'].createElement(
          _SvgIcon3['default'],
          _extends({ className: (0, _classnames2['default'])(classes.svgIcon, className) }, other),
          _react2['default'].createElement('path', { d: 'M0,0 L' + DIA + ',0 A' + DIA + ',' + DIA + ' 0 1,1 ' + cos + ',' + sin + ' Z' })
        );
      }

      return render;
    }()
  }]);

  return PieChart;
}(_SvgIcon3['default']), _class.defaultProps = {
  value: 0,
  viewBox: DIA / -2 + ' ' + DIA / -2 + ' ' + DIA + ' ' + DIA
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager
}, _temp);
exports['default'] = PieChart;


PieChart.displayName = 'PieChart';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/PieChart.js
// module id = 829
// module chunks = 32